import React from 'react';
import { EnergyMainLogoWrapper, EnergyMainLogo } from './energy.style';

export const EnergyLogotype = (): JSX.Element => (
    <EnergyMainLogoWrapper>
        <EnergyMainLogo />
    </EnergyMainLogoWrapper>
);
